import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["select"]

  initialize() {
    this.boundFetchResults = this.fetchResults.bind(this)
  }

  connect() {
    this.choices = new Choices(this.selectTarget, {
      removeItemButton: true,
      searchResultLimit: 10,
      placeholderValue: "Adresse auswählen...",
      searchPlaceholderValue: "Suchbegriff ..."
    })

    this.selectTarget.addEventListener("search", this.boundFetchResults)
  }

  disconnect() {
    this.selectTarget.removeEventListener("search", this.boundFetchResults)
    this.choices?.destroy()
  }

  async fetchResults(event) {
    const query = event.detail.value //.replace(/a_/i, '')
    if (query.length < 3) return // erst ab 3 Zeichen suchen

    const response = await fetch(`/turistad?q=${encodeURIComponent(query)}`)
    const data = await response.json()

    this.choices.setChoices(data, "value", "label", true)
  }
}
